import { render, staticRenderFns } from "./bioInput.vue?vue&type=template&id=38f4d482&scoped=true&"
import script from "./bioInput.vue?vue&type=script&lang=js&"
export * from "./bioInput.vue?vue&type=script&lang=js&"
import style0 from "./bioInput.vue?vue&type=style&index=0&id=38f4d482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4d482",
  null
  
)

export default component.exports